var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.625C4.5 10.8286 4.5 8.43042 5.06627 7.62361C5.63255 6.81681 7.88749 6.04494 12.3974 4.50119L13.2566 4.20708C15.6075 3.40236 16.7829 3 18 3C19.2171 3 20.3925 3.40236 22.7434 4.20708L23.6026 4.50119C28.1125 6.04494 30.3675 6.81681 30.9337 7.62361C31.5 8.43042 31.5 10.8286 31.5 15.625C31.5 16.3495 31.5 17.1351 31.5 17.987C31.5 26.4442 25.1416 30.5482 21.1522 32.2909C20.07 32.7636 19.5289 33 18 33C16.4711 33 15.93 32.7636 14.8478 32.2909C10.8584 30.5482 4.5 26.4441 4.5 17.987C4.5 17.1351 4.5 16.3495 4.5 15.625Z",
    stroke: "currentColor",
    strokeWidth: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 13.5,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22.5C24 24.1569 24 25.5 18 25.5C12 25.5 12 24.1569 12 22.5C12 20.8431 14.6863 19.5 18 19.5C21.3137 19.5 24 20.8431 24 22.5Z",
    stroke: "currentColor",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdmin);
export default __webpack_public_path__ + "static/media/ic_admin.edb70428b8643f53fb113fcfc9172e99.svg";
export { ForwardRef as ReactComponent };